export { InsureesSearch as default } from './insurees-search';
